window.addEventListener("load", function(){
    try{
        const faq = document.querySelector(".faq__content");
        if(faq){
          const sections = faq.querySelectorAll('section[tabindex="0"]');
          sections.forEach((section)=>{
            section.removeAttribute("tabindex");
          });
        }
    } catch(e){
      //console.log(e);
    }
});

function getSlideshowSlideFocusTarget(slide) {
  if (!slide) {
    return null;
  }
  if (slide.matches("a.slideshow__slide")) {
    slide.tabIndex = -1;
    return slide;
  }
  var content = slide.querySelector(".slideshow__slide-content");
  if (content) {
    var interactive = content.querySelector('a[href], button:not([disabled])');
    if (interactive) {
      return interactive;
    }
    content.tabIndex = -1;
    return content;
  }
  slide.tabIndex = -1;
  return slide;
}

function initSlideshowFocusManagement() {
  document.querySelectorAll("slideshow-carousel.slideshow").forEach(function (carousel) {
    var pendingUserNavFocus = false;
    var nav = carousel.querySelector("carousel-navigation");

    carousel.addEventListener("carousel:settle", function (event) {
      if (!pendingUserNavFocus) {
        return;
      }
      pendingUserNavFocus = false;
      var target = getSlideshowSlideFocusTarget(event.detail.cell);
      if (target) {
        target.focus({ preventScroll: true });
      }
    });

    if (!nav) {
      return;
    }

    nav.querySelectorAll("button").forEach(function (button) {
      function markUserNav() {
        if (button.getAttribute("aria-current") === "true") {
          return;
        }
        pendingUserNavFocus = true;
      }

      button.addEventListener("click", markUserNav);
      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          markUserNav();
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {

  /* Cart drawer (launch): document capture opens before theme delegate (no double-close); deferred show avoids ghost click on overlay; initial focus on close control (APG dialog); line-item labels after show/refresh */
  try {
    function cartDrawerEl() {
      return document.querySelector("cart-drawer#cart-drawer");
    }

    function focusCartDrawerCloseButton(drawer) {
      if (!drawer || !drawer.shadowRoot) {
        return;
      }
      var closeBtn = drawer.shadowRoot.querySelector('button[part~="close-button"]');
      if (closeBtn) {
        closeBtn.focus({ preventScroll: true });
      }
    }

    function annotateCartDrawerLineItems() {
      var cartItems = document.querySelectorAll(".cart-drawer__items .line-item");
      var i = 1;
      var j = 1;
      var k = 1;
      var x = 1;
      var y = 1;
      cartItems.forEach(function (lineItem) {
        lineItem.querySelectorAll(".line-item-info .cart-product-title").forEach(function (titleEl) {
          titleEl.setAttribute("id", "head" + i);
          i += 1;
        });
        lineItem.querySelectorAll(".line-item-info quantity-input input").forEach(function (inputEl) {
          inputEl.setAttribute("id", "qty" + j);
          inputEl.setAttribute("aria-labelledby", "qty" + k + " " + "head" + k);
          j += 1;
          k += 1;
        });
        lineItem.querySelectorAll("line-item-quantity>a").forEach(function (removeEl) {
          removeEl.setAttribute("id", "Update" + x);
          removeEl.setAttribute("aria-labelledby", "Update" + x + " " + "head" + y);
          x += 1;
          y += 1;
        });
      });
    }

    function bindCartDrawerA11y(drawer) {
      if (!drawer || drawer.getAttribute("data-mm-cart-a11y") === "1") {
        return;
      }
      drawer.setAttribute("data-mm-cart-a11y", "1");
      drawer.addEventListener(
        "dialog:after-show",
        function () {
          var self = this;
          annotateCartDrawerLineItems();
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              focusCartDrawerCloseButton(self);
            });
          });
        },
        false
      );
      drawer.addEventListener(
        "cart-drawer:refreshed",
        function () {
          annotateCartDrawerLineItems();
        },
        false
      );
    }

    function mmCartDrawerDocumentClickCapture(e) {
      var ctrl = e.target.closest(".header__cart-link [aria-controls=\"cart-drawer\"]");
      if (!ctrl) {
        return;
      }
      var drawer = cartDrawerEl();
      if (!drawer || typeof drawer.show !== "function") {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
      if (drawer.open) {
        drawer.hide();
      } else {
        window.setTimeout(function () {
          var d = cartDrawerEl();
          if (!d || typeof d.show !== "function" || d.open) {
            return;
          }
          d.show();
        }, 0);
      }
    }

    var mmCartDrawerDocListenerBound = false;
    function ensureCartDrawerDocumentListener() {
      if (mmCartDrawerDocListenerBound) {
        return;
      }
      mmCartDrawerDocListenerBound = true;
      document.addEventListener("click", mmCartDrawerDocumentClickCapture, true);
    }

    function setupCartDrawerHeaderA11y() {
      var drawer = cartDrawerEl();
      var ctrl = document.querySelector('.header__cart-link [aria-controls="cart-drawer"]');
      if (!ctrl || !drawer || typeof drawer.show !== "function") {
        return false;
      }
      bindCartDrawerA11y(drawer);
      ensureCartDrawerDocumentListener();
      return true;
    }

    if (!setupCartDrawerHeaderA11y()) {
      customElements.whenDefined("cart-drawer").then(setupCartDrawerHeaderA11y);
      setTimeout(setupCartDrawerHeaderA11y, 0);
      setTimeout(setupCartDrawerHeaderA11y, 400);
    }

    document.addEventListener(
      "shopify:section:load",
      function () {
        setupCartDrawerHeaderA11y();
      },
      false
    );
  } catch (e) {
    // cart drawer init
  }

  /* Captain Compliance cookie settings modal (shadow DOM): full dialog a11y per APG */
  try {
    var CC_TRIGGER_ID = "id-open-settings-cc";
    var CC_HOST_CLASS = "captain-compliance-modal-container";
    var CC_MODAL_ID = "cc-modal-cookies-banner-settings";
    var CC_ALLOW_ID = "cc-modal-allow-selection";
    var CC_CLOSE_ID = "cc-modal-close-all";
    var ccLastTrigger = null;
    var ccFocusTrapHandler = null;
    var ccModalOpen = false;
    var ccModalBound = false;
    var ccTriggerBound = false;
    var ccInertedElements = [];

    function ccGetShadowHost() {
      return document.querySelector("." + CC_HOST_CLASS);
    }

    function ccGetShadowRoot() {
      var host = ccGetShadowHost();
      return host && host.shadowRoot ? host.shadowRoot : null;
    }

    function ccGetModal() {
      var shadowRoot = ccGetShadowRoot();
      return shadowRoot ? shadowRoot.getElementById(CC_MODAL_ID) : null;
    }

    function ccGetActiveElement() {
      var shadowRoot = ccGetShadowRoot();
      if (shadowRoot && shadowRoot.activeElement) {
        return shadowRoot.activeElement;
      }
      return document.activeElement;
    }

    function ccIsModalOpen(modal) {
      if (!modal) {
        return false;
      }
      var style = window.getComputedStyle(modal);
      return style.display !== "none" && style.visibility !== "hidden" && modal.getClientRects().length > 0;
    }

    function ccIsElementHidden(el) {
      if (!el) {
        return true;
      }
      var style = window.getComputedStyle(el);
      return style.display === "none" || style.visibility === "hidden" || el.getAttribute("aria-hidden") === "true";
    }

    function ccSetPageInert(inert) {
      if (!inert) {
        ccInertedElements.forEach(function (el) {
          el.removeAttribute("inert");
        });
        ccInertedElements = [];
        return;
      }

      ccInertedElements = [];
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (!el.classList || !el.classList.contains(CC_HOST_CLASS)) {
          el.setAttribute("inert", "");
          ccInertedElements.push(el);
        }
      });
    }

    function ccInjectA11yStyles(shadowRoot) {
      if (!shadowRoot || shadowRoot.getElementById("mm-cc-a11y-styles")) {
        return;
      }

      var style = document.createElement("style");
      style.id = "mm-cc-a11y-styles";
      style.textContent =
        'label[data-mm-cc-switch][tabindex="0"]:focus, ' +
        'label[data-mm-cc-switch][tabindex="0"]:focus-visible, ' +
        "#" +
        CC_ALLOW_ID +
        ":focus, #" +
        CC_ALLOW_ID +
        ":focus-visible, #" +
        CC_CLOSE_ID +
        ":focus, #" +
        CC_CLOSE_ID +
        ":focus-visible {" +
        "outline: 1px solid black !important;" +
        "outline-offset: 2px;" +
        "}" +
        'label[data-mm-cc-switch][aria-disabled="true"] {' +
        "cursor: not-allowed !important;" +
        "}";

      shadowRoot.appendChild(style);
    }

    function ccEnhanceModalSemantics(modal) {
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");

      var titleEl = modal.querySelector(".captain-compliance-modal-settings-body_content_text_title");
      var descriptionEl = modal.querySelector(".captain-compliance-modal-settings-body_content_text_description");

      if (titleEl && !titleEl.id) {
        titleEl.id = "cc-modal-settings-title";
      }
      if (descriptionEl && !descriptionEl.id) {
        descriptionEl.id = "cc-modal-settings-description";
      }
      if (titleEl) {
        modal.setAttribute("aria-labelledby", titleEl.id);
      }
      if (descriptionEl) {
        modal.setAttribute("aria-describedby", descriptionEl.id);
      }
    }

    function ccEnhanceSwitches(modal) {
      var items = modal.querySelectorAll(".captain-compliance-modal-settings-body_content_switch_list_item");

      items.forEach(function (item, index) {
        var input = item.querySelector('input[type="checkbox"]');
        var toggleLabel = item.querySelector("label[for]");
        var nameEl = item.querySelector(".captain-compliance-modal-settings-body_content_switch_list_item_preset_label");

        if (!input || !toggleLabel) {
          return;
        }

        var switchName = nameEl ? nameEl.textContent.replace(/\s+/g, " ").trim() : "";

        input.setAttribute("tabindex", "-1");
        input.setAttribute("aria-hidden", "true");
        input.removeAttribute("role");
        input.removeAttribute("data-mm-cc-switch");
        input.removeAttribute("data-mm-cc-switch-bound");

        toggleLabel.setAttribute("data-mm-cc-switch", "1");
        toggleLabel.setAttribute("role", "switch");
        toggleLabel.setAttribute("tabindex", "0");

        if (switchName) {
          toggleLabel.setAttribute("aria-label", switchName);
        }

        var wasDisabled = input.disabled;
        if (wasDisabled) {
          input.disabled = false;
          toggleLabel.setAttribute("aria-disabled", "true");
          toggleLabel.setAttribute("data-mm-cc-locked", "1");
        } else {
          toggleLabel.removeAttribute("aria-disabled");
          toggleLabel.removeAttribute("data-mm-cc-locked");
        }

        function syncSwitchState() {
          toggleLabel.setAttribute("aria-checked", input.checked ? "true" : "false");
        }

        syncSwitchState();

        if (!toggleLabel.getAttribute("data-mm-cc-switch-bound")) {
          toggleLabel.setAttribute("data-mm-cc-switch-bound", "1");

          toggleLabel.addEventListener("click", function (e) {
            if (toggleLabel.getAttribute("data-mm-cc-locked") === "1") {
              e.preventDefault();
              e.stopPropagation();
              input.checked = true;
              syncSwitchState();
            }
          });

          toggleLabel.addEventListener("keydown", function (e) {
            if (e.key !== " " && e.key !== "Enter") {
              return;
            }

            e.preventDefault();

            if (toggleLabel.getAttribute("data-mm-cc-locked") === "1") {
              return;
            }

            input.click();
            syncSwitchState();
          });

          input.addEventListener("change", syncSwitchState);
        }
      });
    }

    function ccEnhanceActionButtons(modal) {
      [CC_ALLOW_ID, CC_CLOSE_ID].forEach(function (buttonId) {
        var btn = modal.querySelector("#" + buttonId);
        if (!btn) {
          return;
        }

        var label = btn.textContent.replace(/\s+/g, " ").trim();
        if (label) {
          btn.setAttribute("aria-label", label);
        }

        btn.setAttribute("tabindex", "0");

        if (!btn.getAttribute("data-mm-cc-action-bound")) {
          btn.setAttribute("data-mm-cc-action-bound", "1");

          btn.addEventListener("keydown", function (e) {
            if (e.key !== "Enter" && e.key !== " ") {
              return;
            }
            e.preventDefault();
            btn.click();
          });
        }
      });
    }

    function ccPrepareModal(modal) {
      ccInjectA11yStyles(ccGetShadowRoot());
      ccEnhanceModalSemantics(modal);
      ccEnhanceSwitches(modal);
      ccEnhanceActionButtons(modal);
    }

    function ccGetFocusableElements(modal) {
      var focusables = [];

      modal.querySelectorAll('label[data-mm-cc-switch][tabindex="0"]').forEach(function (toggleLabel) {
        if (!ccIsElementHidden(toggleLabel)) {
          focusables.push(toggleLabel);
        }
      });

      [CC_ALLOW_ID, CC_CLOSE_ID].forEach(function (buttonId) {
        var btn = modal.querySelector("#" + buttonId);
        if (btn && !ccIsElementHidden(btn)) {
          focusables.push(btn);
        }
      });

      return focusables;
    }

    function ccGetModalFocusTarget(modal) {
      var focusables = ccGetFocusableElements(modal);
      return focusables.length ? focusables[0] : null;
    }

    function ccEnableFocusTrap(modal) {
      if (ccFocusTrapHandler) {
        return;
      }

      ccFocusTrapHandler = function (e) {
        if (e.key !== "Tab" || !ccModalOpen || !ccIsModalOpen(modal)) {
          return;
        }

        var focusables = ccGetFocusableElements(modal);
        if (!focusables.length) {
          return;
        }

        var currentIndex = focusables.indexOf(ccGetActiveElement());
        var nextIndex;

        if (e.shiftKey) {
          nextIndex = currentIndex <= 0 ? focusables.length - 1 : currentIndex - 1;
        } else {
          nextIndex = currentIndex === -1 || currentIndex >= focusables.length - 1 ? 0 : currentIndex + 1;
        }

        e.preventDefault();
        focusables[nextIndex].focus({ preventScroll: true });
      };

      document.addEventListener("keydown", ccFocusTrapHandler, true);
    }

    function ccDisableFocusTrap() {
      if (!ccFocusTrapHandler) {
        return;
      }
      document.removeEventListener("keydown", ccFocusTrapHandler, true);
      ccFocusTrapHandler = null;
    }

    function ccFocusModal(modal, sourceTrigger) {
      if (sourceTrigger) {
        ccLastTrigger = sourceTrigger;
      }

      ccPrepareModal(modal);
      ccModalOpen = true;
      ccSetPageInert(true);
      ccEnableFocusTrap(modal);

      window.setTimeout(function () {
        if (!ccIsModalOpen(modal)) {
          return;
        }

        ccPrepareModal(modal);
        var target = ccGetModalFocusTarget(modal);
        if (target) {
          target.focus({ preventScroll: true });
        }
      }, 100);
    }

    function ccReturnFocusToTrigger() {
      ccModalOpen = false;
      ccDisableFocusTrap();
      ccSetPageInert(false);

      if (ccLastTrigger && document.contains(ccLastTrigger)) {
        window.setTimeout(function () {
          ccLastTrigger.focus({ preventScroll: true });
        }, 50);
      }
    }

    function ccWaitForModalOpen(sourceTrigger, attempts) {
      if (sourceTrigger) {
        ccLastTrigger = sourceTrigger;
      }

      var modal = ccGetModal();
      if (!modal) {
        if (attempts < 60) {
          window.setTimeout(function () {
            ccWaitForModalOpen(sourceTrigger, attempts + 1);
          }, 100);
        }
        return;
      }

      if (!ccModalBound) {
        ccBindModal(modal);
      }

      if (ccIsModalOpen(modal)) {
        ccFocusModal(modal, sourceTrigger);
        return;
      }

      if (attempts < 60) {
        window.setTimeout(function () {
          ccWaitForModalOpen(sourceTrigger, attempts + 1);
        }, 100);
      }
    }

    function ccBindModal(modal) {
      if (!modal || ccModalBound) {
        return;
      }
      ccModalBound = true;
      ccPrepareModal(modal);

      var observer = new MutationObserver(function () {
        if (ccIsModalOpen(modal)) {
          ccPrepareModal(modal);
          if (!ccModalOpen) {
            ccFocusModal(modal, ccLastTrigger);
          }
        } else if (ccModalOpen) {
          ccReturnFocusToTrigger();
        }
      });

      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["style", "class", "hidden", "aria-hidden"]
      });

      modal.addEventListener(
        "click",
        function (e) {
          var action = e.target.closest("#" + CC_CLOSE_ID + ", #" + CC_ALLOW_ID);
          if (!action) {
            return;
          }
          window.setTimeout(ccReturnFocusToTrigger, 100);
        },
        false
      );

      document.addEventListener(
        "keydown",
        function (e) {
          if (e.key !== "Escape" || !ccModalOpen || !ccIsModalOpen(modal)) {
            return;
          }
          e.preventDefault();
          var closeBtn = modal.querySelector("#" + CC_CLOSE_ID);
          if (closeBtn) {
            closeBtn.click();
          }
          window.setTimeout(ccReturnFocusToTrigger, 100);
        },
        false
      );
    }

    function ccBindTrigger(trigger) {
      if (!trigger || ccTriggerBound) {
        return;
      }
      ccTriggerBound = true;
      trigger.setAttribute("aria-haspopup", "dialog");

      trigger.addEventListener("keydown", function (e) {
        if (e.key === " ") {
          e.preventDefault();
          trigger.click();
        }
      });
    }

    function ccInitCaptainComplianceA11y() {
      var trigger = document.getElementById(CC_TRIGGER_ID);
      var modal = ccGetModal();

      if (trigger) {
        ccBindTrigger(trigger);
      }
      if (modal) {
        ccBindModal(modal);
      }

      return !!modal;
    }

    document.addEventListener(
      "click",
      function (e) {
        var trigger = e.target && e.target.id === CC_TRIGGER_ID ? e.target : null;
        if (!trigger && e.target && e.target.closest) {
          trigger = e.target.closest("#" + CC_TRIGGER_ID);
        }
        if (!trigger) {
          return;
        }
        ccWaitForModalOpen(trigger, 0);
      },
      true
    );

    if (!ccInitCaptainComplianceA11y()) {
      var ccBodyObserver = new MutationObserver(function () {
        if (ccInitCaptainComplianceA11y()) {
          ccBodyObserver.disconnect();
        }
      });
      ccBodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  } catch (e) {
    // Captain Compliance modal init
  }

  /* Media grid video ADA: native button overlay for reliable focus, single tab stop until play */
  try {
    const mediaGrid = document.querySelector('.media-grid');
    if (mediaGrid) {
      const videoMediaElements = mediaGrid.querySelectorAll('video-media[show-play-button]:not([autoplay])');
      videoMediaElements.forEach(function(videoMedia) {
        var video = videoMedia.querySelector('video');
        var posterImg = videoMedia.querySelector('img');
        if (video) video.setAttribute('tabindex', '-1');
        if (posterImg) posterImg.setAttribute('tabindex', '-1');

        var playBtn = null;
        var hasDeferControls = videoMedia.hasAttribute('data-defer-controls');

        function createPlayButton() {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'media-grid-play-trigger';
          btn.setAttribute('aria-label', 'Play video');
          btn.innerHTML = '<span class="sr-only">Play video</span>';
          videoMedia.parentNode.insertBefore(btn, videoMedia.nextSibling);
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            videoMedia.play();
          });
          btn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              videoMedia.play();
            }
          });
          return btn;
        }

        function onVideoPlaying() {
          if (hasDeferControls && video) video.controls = true;
          if (video) {
            video.removeAttribute('tabindex');
            video.setAttribute('tabindex', '0');
          }
          if (posterImg) posterImg.removeAttribute('tabindex');
          if (playBtn && playBtn.parentNode) playBtn.remove();
          playBtn = null;
        }

        function onVideoPaused() {
          if (video) {
            video.removeAttribute('tabindex');
            video.setAttribute('tabindex', '0');
          }
          if (posterImg) posterImg.removeAttribute('tabindex');
        }

        if (!videoMedia.closest('a.media-grid__item')) {
          playBtn = createPlayButton();
        }

        var playObserver = new MutationObserver(function() {
          if (videoMedia.hasAttribute('playing')) {
            onVideoPlaying();
          } else {
            onVideoPaused();
          }
        });
        playObserver.observe(videoMedia, { attributes: true, attributeFilter: ['playing'] });
      });

      const contentOverMediaWithVideo = [];
      videoMediaElements.forEach(function(vm) {
        const parent = vm.closest('.content-over-media');
        if (parent && !contentOverMediaWithVideo.includes(parent)) {
          contentOverMediaWithVideo.push(parent);
        }
      });
      contentOverMediaWithVideo.forEach(function(contentOverMedia) {
        const prose = contentOverMedia.querySelector('.prose');
        if (prose) {
          prose.setAttribute('inert', '');
          const videoMedia = contentOverMedia.querySelector('video-media');
          if (videoMedia) {
            const observer = new MutationObserver(function() {
              if (videoMedia.hasAttribute('playing')) {
                prose.removeAttribute('inert');
              } else {
                prose.setAttribute('inert', '');
              }
            });
            observer.observe(videoMedia, { attributes: true, attributeFilter: ['playing'] });
          }
        }
      });
    }
  } catch (e) {
    // Media grid video ADA init
  }

  try{
    //#28
    function fixPopup(){
      if(document.querySelectorAll("form.needsclick").length > 0){
        document.querySelectorAll("form.needsclick").forEach((form, formIndex)=>{
          form.querySelectorAll("input").forEach((input, inputIndex)=>{
            let inputID = '';
            if(input.getAttribute("ID")){
              inputID = input.getAttribute("ID");
            } else {
              inputID = 'ada-form-'+formIndex+'-'+inputIndex;
              input.setAttribute("id", inputID);
            }
            let label = document.createElement("label");
            label.innerText = input.placeholder;
            label.setAttribute("for", inputID);
            label.className = "sr-only";
            input.insertAdjacentElement("beforebegin", label);
          });
        
        });
      } else {
        setTimeout(()=>{
          fixPopup();
        }, 1000)
      }
    }
    fixPopup();
  } catch(e){
    //console.log(e)
  }

  // 9.Empty "alt" attribute provided for informative image link
  let megamenu_alt_text = document.querySelectorAll('.mega-menu .mega-menu__promo');
  if(megamenu_alt_text){
  	for (i=0; i<megamenu_alt_text.length; i++){
  		let getText = megamenu_alt_text[i].querySelector('.v-stack p.h6');        
  		let setText = megamenu_alt_text[i].querySelector('a.v-stack img');
        let text = getText.textContent;
        setText.alt = text;
  	}
    
  }

  // 
  document.querySelector('.footer__inner .footer__block.footer__block--image a > img').alt = 'ADA Site Compliance-Accessibility Policy';

 //

    let ariaLabels = ['From price $', 'To price $', 'From price $', 'To price $'];
      document.querySelectorAll('.accordion-list .price-range .input-group input').forEach((input, index) => {
          if (index < ariaLabels.length) {
              input.setAttribute('aria-label', ariaLabels[index]);
          }
      });
  
  
  //

    var successBanner = document.querySelector('#contact_form .banner--success');
      if (successBanner) {
        successBanner.setAttribute('role', 'status');
        successBanner.setAttribute('aria-live', 'polite');
    }



  //

var firstLink = document.querySelector(".main-search__resource-item .blog-post-card a");
if (firstLink) {
    firstLink.setAttribute("aria-label", "Read more on 20 YEARS OF PILLOWS AND PILLOW TALK WITH THE PILLOW BUTLER® TEAM AT DOWN ETC");
} 

  //
    const currentPath = window.location.pathname;
      
      if (currentPath.endsWith('down-bed-pillows')) {      
      document.title = 'down and feather bed pillows | Down etc';
        } else if (currentPath.endsWith('contact')) {
            document.title = 'Contact | Down etc';
    } 
  
  //
  let local_lang_button = document.querySelectorAll('.shopify-localization-form .popover__value-list button, button.localization-toggle.heading.text-xxs.link-faded');
  if(local_lang_button){
    setTimeout(()=>{
        let j = 1;
        // let k = 2;
    	for (i=0; i<local_lang_button.length; i++){
          local_lang_button[i].querySelector('span').id = 'ex'+j;
          // local_lang_button[i].id = 'ex'+k;
// local_lang_button[i].setAttribute('aria-labelledby', 'ex'+j+' '+'ex'+k);
          local_lang_button[i].setAttribute('aria-labelledby', 'ex'+j);
          j+=1;
          // k+=2;
    	}        
    }, 100)
  }


  try {
    document.querySelectorAll(".slideshow").forEach(function (slide) {
      slide.role = "region";
      slide.ariaLabel = "Carousel";
      slide.ariaLive = "polite";
    });
    initSlideshowFocusManagement();
  } catch (e) {
    // Slideshow focus management
  }

var Learn_more = document.querySelector('a[href="/pages/our-brand"][title="Our Brand"]');
if (Learn_more) {
    Learn_more.setAttribute('aria-label', 'Learn more about our values');
}

document.querySelectorAll("h2.h2").forEach(function(h2) {
    if (h2.textContent.includes("Frequently Asked Questions")) {
        var h1 = document.createElement("h1");
        h1.innerHTML = h2.innerHTML;
        h1.className = h2.className;
        h2.parentNode.replaceChild(h1, h2);
    }
});

  
  setTimeout(function() {
    var items = document.querySelectorAll("#insta-feed .instafeed-new-layout-item .instafeed-new-layout-item-container");
    items.forEach(function(item, index) {      
      item.setAttribute("aria-label", "Open Instagram post " + (index + 1)); 
      const child = item.querySelector(".instafeed-hover-layer");
      child.setAttribute("tabindex", "-1");
      child.removeAttribute("aria-label");
       
    });

    var sort_by_review = document.querySelector('select#kl_reviews__sort_by_reviews');
    if(sort_by_review){
       sort_by_review.setAttribute('title', 'Sort by rating');
    }
     var rating_number = document.querySelector('select#kl_reviews__filter_reviews_rating');
    if(rating_number){
       rating_number.setAttribute('title', 'Filter by rating number');
    }
 
    // 

    var popup = document.querySelector('.needsclick span.ql-font-century-gothic');

    if (popup) {
      var h2 = document.createElement('h2');   
      h2.innerHTML = popup.innerHTML;   
      
      popup.parentNode.replaceChild( h2, popup);
    }
    //
    document.querySelectorAll('.predictive-search__content .product-card').forEach(function(element) {
    element.setAttribute('role', 'tabpanel');
    }); 

    //
    document.querySelectorAll('.predictive-search__content button.h6').forEach(function(element) {
        element.setAttribute('role', 'tablist');
    });  
    
  }, 10000); 

   setTimeout(function() {

     // 
    let shippingAddress = document.querySelector("#checkout-main #shippingAddressForm button svg")
    if (shippingAddress) {
      shippingAddress.setAttribute('aria-label', 'More information on phone number');
    }
  
    // #75

     var paginationNav = document.querySelector('.section-stack nav.pagination');
        if (paginationNav) {
        paginationNav.removeAttribute('role');
        paginationNav.setAttribute("aria-label", "pagination");
        }  
     
    // 
    
    // const updateTitle = () => {
    // const originalTitle = document.title;
    // const url = window.location.href;
    // const urlObj = new URL(url);
    // const params = new URLSearchParams(urlObj.search);
    // const pageValue = params.get("page");
    // if (pageValue) {
    //     const titlePrefix = originalTitle.split(" | ")[0];
    //     const newTitle = `${titlePrefix}  | Down etc`;
    //     document.title = newTitle;
    //     }
    // };
    // updateTitle();

     var i = 1;
      document.querySelectorAll(".cart-drawer__items .line-item").forEach(function (lineItem) {
          var downCartItemAnchor = lineItem.querySelector(".down_cart_item a");
          var downRemoveLinkAnchor = lineItem.querySelector(".down_remove a.link");
          if (downCartItemAnchor) {
              downCartItemAnchor.id = "head" + i;
          }
          if (downRemoveLinkAnchor) {
              downRemoveLinkAnchor.id = "Update" + i;
              downRemoveLinkAnchor.setAttribute('aria-labelledby', 'Update' + i + ' ' + 'head' + i);
          }
          i++;
   });

  //   
    const button = document.querySelector('.cart-drawer__footer button.link-faded-reverse');
    if(button){
      const h3 = document.createElement('h3');
      h3.style.fontSize = '14px';
      h3.style.fontWeight = '500';
      button.parentNode.insertBefore(h3, button);
      h3.appendChild(button);

    }
      
  // 
      document.querySelector('.header__secondary-nav a[href="/search"]').addEventListener("click", function() {
        this.setAttribute("aria-expanded", "false");
        document.querySelector('.header__secondary-nav a[href="/search"]').setAttribute("aria-expanded", "true");
    });
      document.querySelector('.header__secondary-nav a[href="/search"]').setAttribute("aria-expanded", "false");
 //
     let images = document.querySelectorAll('img');
        images.forEach(function(image) {
    if (image.src.includes('HEXAGON_sheet_size_guide_2.png')) {
        image.setAttribute('alt', 'Sheet Size Guide');
        }
    });

     
  }, 2000); 

  document.querySelectorAll('.section-stack .blog-post-list a img').forEach(function(img) {
    img.setAttribute('alt','');
  });

  //  
  
    

  
  


  //document.querySelectorAll("#shopify-section-template--17112103616666__contact-form .prose h2").forEach(function(h2) {
  // aeye rewrite selector: ID issue
  document.querySelectorAll('section[id$="__contact-form"] .prose h2').forEach(function(h2) {
  const h1 = document.createElement("h1");
     h1.className = h2.className;
     h1.innerHTML = h2.innerHTML; 
     h2.parentNode.replaceChild(h1, h2);
  });

  // Cart line-item ids/labels: wired from cart-drawer dialog:after-show + cart-drawer:refreshed (see top of file)

  // 

 
// function updateAriaHaspopup(button) {
//         const ariaExpanded = button.getAttribute('aria-expanded');
//         // Set 'aria-haspopup' to 'true' if 'aria-expanded' is 'true', otherwise 'false'
//         button.setAttribute('aria-haspopup', ariaExpanded === 'true' ? 'true' : 'false');
//     }

//     // Initial update on page load
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         updateAriaHaspopup(button);
//     });

//     // Add click event listener to update 'aria-haspopup' on button click
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         button.addEventListener('click', function() {
//             // Directly update 'aria-haspopup' based on current 'aria-expanded'
//             updateAriaHaspopup(button);
//         });
//     });

  // 

  let contact_form = document.querySelector('#contact_form > div.fieldset');
  if (contact_form) {
      let divElement = document.createElement('div');
      let divContent = document.createTextNode('* denotes mandatory fields');
      divElement.appendChild(divContent);
      divElement.classList.add('contact-mandatory');
      divElement.style.color = 'red';
      contact_form.parentNode.insertBefore(divElement, contact_form);
  }

         const labels = document.querySelectorAll('#contact_form .floating-label');
         const selectedLabels = [labels[0], labels[1],labels[3]];
         selectedLabels.forEach(function(label) {
            if (label) {
                label.innerHTML += '*';
            }
        });

  // Custom validation messages: "Please fill out the [field name]" for contact and newsletter forms
  function setupFieldValidationMessages(form) {
    if (!form) return;
    const fields = form.querySelectorAll('input[required], textarea[required], select[required]');
    fields.forEach(function(field) {
      const msg = field.getAttribute('data-validation-message');
      if (!msg) return;
      field.addEventListener('invalid', function() {
        this.setCustomValidity(msg);
      });
      field.addEventListener('input', function() { this.setCustomValidity(''); });
      field.addEventListener('change', function() { this.setCustomValidity(''); });
    });
  }
  document.querySelectorAll('form').forEach(function(form) {
    if (form.querySelector('[data-validation-message]')) setupFieldValidationMessages(form);
  });

  // #78
  // try {
  //   const sidebarLinks = document.querySelector(".faq__toc");
  //   const listItems = sidebarLinks.querySelectorAll("li");
    
  //   for (let i = 0; i < listItems.length; i++) {
  //     listItems[i].querySelector("a").addEventListener("click", function(event) {
  //       updateSelectedLinks(event);
  //     });
  
  //     listItems[i].querySelector("a").addEventListener("keydown", function(event) {
  //       if (event.key === "Enter") {
  //         updateSelectedLinks(event);
  //       }
  //     });
  //   }
  
  //   function updateSelectedLinks(event) {
  //     const existingSelectedLink = sidebarLinks.querySelector("#selected-link");
  //     if (existingSelectedLink) {
  //       existingSelectedLink.remove();
  //     }
      
  //     const span = document.createElement("span");
  //     span.className = "sr-only";
  //     span.id = "selected-link";
  //     span.textContent = "Selected";
      
  //     event.currentTarget.appendChild(span);
  //     adjustActiveClass(event);
  //   }
  
  //   function adjustActiveClass(event) {    
  //     const activeElement = document.querySelector(".is-active");
  //     const adaActiveElement = document.querySelector(".ada-is-active");
  //     if(adaActiveElement) {
  //       adaActiveElement.classList.remove("ada-is-active");
  //       adaActiveElement.style.borderBottom = "none";
  //       adaActiveElement.style.background = "none";
  //     } else if (activeElement) {
  //       activeElement.classList.remove("is-active");
  //       activeElement.style.borderBottom = "none";
  //       activeElement.style.background = "none";
  //     } 
    
  //     const targetLink = event.currentTarget || event.target;
  //     if (targetLink) {
  //       targetLink.classList.add("ada-is-active");
  //       targetLink.style.borderBottom = "1px solid #000";
  //     } else {
  //       console.error("targetLink is undefined or null", event);
  //     }
  //   }
  // } catch (e) {
  //   console.warn(e);
  // }


    var ids = [
        'block-category_WicGiP',
        'block-category_RztHgi',
        'block-category_NfGn4j',
        'block-category_dmK98X',
        'block-category_VYRK6G'
    ];
    
    var selector = ids.map(id => `h2#${id}`).join(', ');    
    var targetH2s = document.querySelectorAll(selector);

    
    targetH2s.forEach(function(targetH2) {        
        var section = document.createElement('section');
        section.id = targetH2.id;
        section.tabIndex = 0;         
        var nextElement = targetH2.nextElementSibling;
        while (nextElement && nextElement.tagName !== 'H2') {
            var nextSibling = nextElement.nextElementSibling;
            section.appendChild(nextElement);
            nextElement = nextSibling;
        }        
        targetH2.parentNode.insertBefore(section, targetH2.nextSibling);
    });

    
    document.querySelectorAll('.faq ul a[href]').forEach(function(anchor) {
        var hrefValue = anchor.getAttribute('href');
        var targetId = hrefValue.substring(1);

        anchor.addEventListener('click', function(e) {
            if (e.type === 'click' || e.key === 'Enter') {
                e.preventDefault();
                var targetSection = document.querySelector('.faq__content h2#' + targetId);
                if (targetSection) {
                    targetSection.setAttribute('tabindex', '0');
                    targetSection.focus();
                }
            }
        });

        anchor.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                var targetSection = document.querySelector('.faq__content h2#' + targetId);
                if (targetSection) {
                    targetSection.setAttribute('tabindex', '0');
                    targetSection.focus();
                }
            }
        });

    // #81+, un-requested functionality
    /*document.querySelectorAll('.faq__content section#' + targetId).forEach((section) => {    
    section.querySelectorAll('details').forEach((detailsElement, index, detailsElements) => {
        const summaryElement = detailsElement.querySelector('summary');        
        if (index === detailsElements.length - 1) {
            summaryElement.addEventListener('keydown', function(e) {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    const targetAnchor = document.querySelector("a[href='" + hrefValue + "']");
                    if (targetAnchor) {
                        targetAnchor.focus();
                    }
                }
            });
        }        
        if (index === 0) {
            summaryElement.addEventListener('keydown', function(e) {
                if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault();
                    const targetAnchor = document.querySelector("a[href='" + hrefValue + "']");
                    if (targetAnchor) {
                        targetAnchor.focus();
                    }
                }
            });
        }
    });
});*/
    });
    
    document.querySelectorAll('.faq__content section summary').forEach(summary => {
        summary.setAttribute('tabindex', '0');
    });

// aeye: no longer applies to current structure  (needed for ADA Copy of Prestige 10.0.2 structure)
   // var summaries = document.querySelectorAll('#block-category_VYRK6G summary');
   //  if (summaries.length > 1) {
   //      var secondSummary = summaries[1];        
   //      secondSummary.addEventListener('keydown', function(e) {
   //          if (e.key === 'Tab' && !e.shiftKey) {
   //              e.preventDefault();
   //              var targetInput = document.querySelector("input#input--sections--17112099815578__newsletter_PVnnHe--contactemail");
   //              if (targetInput) {
   //                  targetInput.focus();
   //              }
   //          }
   //      });
   //  }
  

function replaceTextWithTags() {    
    const paragraphs = document.querySelectorAll('.prose p');    
    paragraphs.forEach(p => {
        const strong = p.querySelector('strong');
        if (strong) {
            switch (strong.textContent.trim().toLowerCase()) {
                // case 'product dimensions:':
                //     const h2Dimension = document.createElement('h2');
                //     const strongDetail = document.createElement('strong');
                //     strongDetail.textContent = 'Product Dimension'; // Capitalized for consistency
                //     h2Dimension.appendChild(strongDetail);
                //     p.parentNode.replaceChild(h2Dimension, p); // Replaces the <p> with <h2>
                //     break;

                case 'product details':
                    const h2Details = document.createElement('h2');
                    const strongDetails = document.createElement('strong');
                    strongDetails.textContent = 'Product Details:'; 
                    h2Details.appendChild(strongDetails);
                    p.parentNode.replaceChild(h2Details, p); 
                    break;

                case 'flat sheet':
                    const h3FlatSheet = document.createElement('h3');
                    const h3strongDetails = document.createElement('strong');
                    h3strongDetails.textContent = 'Flat Sheet'; 
                    h3FlatSheet.appendChild(h3strongDetails);
                    p.parentNode.replaceChild(h3FlatSheet, p); 
                    break;

                case 'fitted sheet':
                    const h3FittedSheet = document.createElement('h3');
                    const h3strongDetail = document.createElement('strong');
                    h3FittedSheet.className = 'kl_reviews__review__title';
                    h3strongDetail.textContent = 'Fitted Sheet';
                    h3FittedSheet.appendChild(h3strongDetail); 
                    p.parentNode.replaceChild(h3FittedSheet, p); 
                    break;
                case 'pillowcases':
                    const pillowCases = document.createElement('h3');
                    const strongPillowcases = document.createElement('strong');                    
                    strongPillowcases.textContent = 'pillowcases';
                    pillowCases.appendChild(strongPillowcases); 
                    p.parentNode.replaceChild(pillowCases, p); 
                    break;
                case 'care instructions':
                    const careInstructions = document.createElement('h3');
                    const strongCareInstructions = document.createElement('strong');                    
                    strongCareInstructions.textContent = 'care instructions:';
                    careInstructions.appendChild(strongCareInstructions); 
                    p.parentNode.replaceChild(careInstructions, p); 
                    break;
            }
        }
    });
}
replaceTextWithTags();

document.addEventListener('click', function(event) {    
    if (event.target.matches("a.pagination__link")) {
        const link = event.target;
        const url = new URL(link.href);
        const pageValue = url.searchParams.get("page");
        setTimeout(function() {
          if (pageValue) {         
              event.preventDefault();    
              window.history.pushState(null, "", url);
              updateTitle(); 
          }
        }, 100);
    }
});

window.addEventListener('popstate', function() {
    updateTitle();
});

function updateTitle() {
    const originalTitle = document.title;
    const url = new URL(window.location.href);
    const pageValue = url.searchParams.get("page");
    if (pageValue) {
        const titlePrefix = originalTitle.split(" | ")[0];
        const titlePrefixs = titlePrefix.split(" - ")[0];
        //console.log(titlePrefixs);
        const newTitle = `${titlePrefixs} - Page ${pageValue} | down etc`;
        document.title = newTitle;
    }
}
window.addEventListener('load', updateTitle);



document.querySelectorAll('button.before-after__cursor').forEach(button => {    
    const span = document.createElement('span');
    span.classList.add('sr-only'); 
    button.appendChild(span);    
    button.addEventListener('focus', () => {
        span.textContent = 'selected'; 
    });    
    button.addEventListener('blur', () => {
        span.textContent = 'deselected'; 
    });
});

// aeye rewrite 
  setTimeout(function() {
  function createLabel(inputElem, labelText) {
    const matchedElement = document.querySelector(inputElem);
    if (!matchedElement || !matchedElement.id) {
      return;
    }

    const inputId = matchedElement.id;
    const inputElement = document.getElementById(inputId);
      if (inputElement && !inputElement.previousElementSibling) {
          const label = document.createElement('label');
          const innerHtmlCondition = inputElement.hasAttribute('aria-required');
          label.setAttribute('for', inputId);
          label.classList.add('sr-only'); // Apply 'sr-only' class
          label.innerHTML = innerHtmlCondition ? `${labelText} <span>*</span>` : label.innerHTML = labelText;
          inputElement.parentNode.insertBefore(label, inputElement);
      }
      if (inputElement && inputElement.previousElementSibling ) {
        if (inputElement.previousElementSibling.tagName !== 'LABEL') {
          const label = document.createElement('label');
          const innerHtmlCondition = inputElement.hasAttribute('aria-required');
          label.setAttribute('for', inputId);
          label.classList.add('sr-only'); // Apply 'sr-only' class
          label.innerHTML = innerHtmlCondition ? `${labelText} <span>*</span>` : label.innerHTML = labelText;
          inputElement.parentNode.insertBefore(label, inputElement);
        } 
      }
  }
  createLabel('[id^="first_name_"]', 'First Name');
  createLabel('[id^="last_name_"]', 'Last Name');
  createLabel('[id^="email_"]', 'Email Address');
}, 10000); 
  
// aeye rewrite above: ID issue
//  setTimeout(function() {
// function createLabel(inputId, labelText) {
//     const inputElement = document.getElementById(inputId);
//     if (inputElement) {
//         const label = document.createElement('label');
//         label.setAttribute('for', inputId);
//         label.classList.add('sr-only'); // Apply 'sr-only' class
//         label.innerHTML = `${labelText} <span>*</span>`;
//         inputElement.parentNode.insertBefore(label, inputElement);
//     }
// }
// createLabel('first_name_109954940', 'First Name');
// createLabel('last_name_109954941', 'Last Name');
// createLabel('email_109954942', 'Email Address');
//   }, 10000); 


  try{
    var button_link = document.querySelector(".variant-picker__option button.link");
    document.querySelector(".prose.size-chart-page img").setAttribute("alt","Sheet Size Guide");
    document.addEventListener("click", function(event) {    
        if (button_link || event.target !== button_link) {        
            setTimeout(function() {
                button_link.removeAttribute("aria-expanded");
            }, 10);
        }
    });
  } catch(e){
    //console.warn(e)
  }


  let blogLinks = document.querySelectorAll(".blog-post-card")
  for(i=0;i<blogLinks.length;i++){
    let headerText = blogLinks[i].querySelector(".blog-post-card__title");
    headerText.setAttribute("role", "heading");
    headerText.setAttribute("aria-level", "2")
  }

});



// document.addEventListener('DOMContentLoaded', function() {
//     // Function to update 'aria-haspopup' based on 'aria-expanded'
//     function updateAriaHaspopup(button) {
//         const ariaExpanded = button.getAttribute('aria-expanded');
//         if (ariaExpanded === 'true') {
//             button.setAttribute('aria-haspopup', 'true213');
//         } else {
//             button.setAttribute('aria-haspopup', 'false213');
//         }
//     }

//     // Initial update on page load
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         updateAriaHaspopup(button);
//     });

//     // Add click event listener to update 'aria-haspopup' on button click
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         button.addEventListener('click', function() {
//             alert(1);
//             // const currentExpanded = button.getAttribute('aria-expanded') === 'true';
//             // button.setAttribute('aria-expanded', !currentExpanded ? 'true' : 'false');
//             // updateAriaHaspopup(button);
            
//         });
//     });
// });